import { TouchableOpacity } from "react-native";
import { Colors, View } from "react-native-ui-lib";

export type PaginationProps = {
  currentPage: number;
  goToPage: (page: number) => void;
  totalPages: number;
  endAdornment?: React.ReactNode;
};

export const Pagination = ({
  currentPage,
  goToPage,
  totalPages,
  endAdornment,
}: PaginationProps) => {
  const navDots: any[] = [];

  for (let i = 1; i <= totalPages; i++) {
    navDots.push(
      <TouchableOpacity
        style={{
          height: 10,
          width: 10,
          backgroundColor:
            i == currentPage ? Colors.$iconPrimary : Colors.neutralButton,
          borderRadius: 10 / 2,
          margin: 6,
        }}
        key={i}
        onPress={() => {
          goToPage(i);
        }}
      />
    );
  }

  return (
    <View
      style={{
        flexDirection: "row",
        justifyContent: "center",
        alignItems: "center",
        minHeight: 50,
      }}
    >
      <View
        style={{
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "center",
        }}
      >
        {navDots}
        {endAdornment}
      </View>
    </View>
  );
};
